<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import axios from "axios";
export default {
  components: {},
  data() {
    return {
      webpage: [
        "Login",
        "ForgotPassword",
        "ResetPassword",
        "Registration",
        "OTPValidation",
        "ForgotPasswordSuccess",
        "PrivacyPolicy",
      ],
    };
  },
  mounted() {
    let current_page = this.$route.name;
    // if(current_page !== 'Login' || current_page !== 'ForgotPassword' || current_page !== 'ResetPassword' || current_page !== 'Registration' || current_page !== 'OTPValidation' || current_page !== 'ForgotPasswordSuccess'){

    if (!this.webpage.includes(current_page)) {
      if (this.$store.getters.subaccounts.length === 0) {
        this.$router.push("/");
        return;
      }

      let data = this.loadNew({
        vendor_no: this.$store.getters.vendor_no,
        primary_legal_entity: this.$store.getters.entity,
      });
      axios({
        method: "get",
        url: this.$hostname + "/get-accounts-by-legal-entity",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.getters.headerstoken}`,
          "X-Request-IV": data.iv
        },
        params: { token: data.cipher },
      })
        .then((res) => {
          if (!res.data.status) {
            this.$router.push("/");
            return;
          }

          if (!res.data.data || res.data.data.length === 0) {
            const legalEntity = res.data.primary_legal_entity;
            const errorMessage =
              legalEntity === "HFMN"
                ? "Honeywell account isn't registered to this user yet"
                : "FMN account isn't registered for this user yet";

            this.$swal.fire("Alert", errorMessage, "error");
            this.$router.push("/");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$router.push("/");
        });
    }
  },
};
</script>
